<script setup lang="ts">

import { computed } from 'vue';
import { usePresentation } from '@/modules/Presentation/Types';
import { useLead } from "../../Types/Lead";
import { useForm, Form } from "@library/Components/Forms/Form/v2";
import { AgeGroup, Gender, Interest, LeadOptions, LeadType } from '../../Types/LeadOptions';
import { Map } from '../../Types/Map';

import SelectOption from "../../Components/SelectOption.vue";

const lead = useLead();
const form = await useForm( lead );
const presentation = usePresentation();
presentation.backgroundImage = '/images/sample/gkr-watermark.png';

presentation.canProceed = () => lead.interestTimeline != null;
presentation.onSetNext = () => 
{
    if( lead.leadType == LeadType.self && lead.ageGroup != AgeGroup.adolescent )
    {
        return { section: Map.FamilyTraining, page: 0 }
    }
    return null;
};

const imageSrc = computed( () => {
    if( lead.interest == Interest.competition ) return 'competition'
    if( lead.interest == Interest.confidence ) return 'confidence'
    if( lead.interest == Interest.fitness ) return 'fitness'
    if( lead.interest == Interest.selfDefence && lead.hasFemale ) return 'self-defence-female'
    if( lead.interest == Interest.selfDefence && lead.hasMale ) return 'self-defence-male'
    return 'self-discipline';
})

</script>

<template>

    <Page>
    
        <ImageAndText 
            :src="`/InterestTimeline/${imageSrc}.jpg`" 
            floor-shadow 
            border>

            <Form 
                :form="form"
                v-slot="{ model, state }"
                class="flex flex-col gap-8">

                <h1 class="mt-6">How long have you (or they) been thinking about starting karate — or something similar?</h1>

                <SelectOption 
                    v-model="model.interestTimeline" 
                    :options="LeadOptions.interestTimeline"               
                />

            </Form>

        </ImageAndText>

    </Page>

</template>